<template>
  <div id="check-in-non-attivato">
    <br />
    <div>
      <h2>Check-in online non attivato</h2>
      <p style="text-align: justify">
        La funzione di check-in online per la prenotazione N.
        {{ reservation_code }} non è ancora stata attivata. Si prega di provare
        più tardi. Nel caso in cui il check-in online non fosse disponibile
        entro un tempo ragionevole, Vi preghiamo di contattare direttamente la
        struttura presso la quale avete effettuato la prenotazione oppure
        inviare un'email a:
        <a v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn">{{
          $store.state.EmailFacileCheckIn
        }}</a
        >.
      </p>
      <p>
        Ci scusiamo per il disagio.
        <br /><NomeSitoPiccolo />
      </p>
    </div>
    <br />

    <div>
      <h2>Check-in data entry not activated</h2>
      <p style="text-align: justify">
        The check-in data entry function for reservation N.
        {{ reservation_code }} has not yet been activated. Please try later. In
        case online check-in is not available within a reasonable time, please
        contact the facility where you made the reservation or send an email to:
        <a v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn">{{
          $store.state.EmailFacileCheckIn
        }}</a
        >.
      </p>
      <p>
        We apologize for the inconvenience.
        <br /><NomeSitoPiccolo />
      </p>
    </div>
    <br />

    <div>
      <h2>Die Check-In-Dateneingabefunktion nicht aktiviert</h2>
      <p style="text-align: justify">
        Die Check-In-Dateneingabefunktion für Reservierung N
        {{ reservation_code }} ist noch nicht aktiviert. Bitte versuchen Sie es
        später noch einmal. Wenn der Online-Check-in nicht innerhalb eines
        angemessenen Zeitraums möglich ist, wenden Sie sich bitte an das Objekt,
        in dem die Reservierung vorgenommen wurde, oder senden Sie eine E-Mail
        an:
        <a v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn">{{
          $store.state.EmailFacileCheckIn
        }}</a
        >.
      </p>
      <p>
        Wir entschuldigen uns für die Unannehmlichkeiten.
        <br /><NomeSitoPiccolo />
      </p>
    </div>
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";

export default {
  name: "CheckInNonAttivato",
  data() {
    return {};
  },
  components: {
    NomeSitoPiccolo,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  props: {
    reservation_code: String,
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "CheckInNonAttivato-fn_CambiaLingua");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
